import { giphyDarkestGrey } from '@giphy/js-brand'
import { Button } from 'shared/components/buttons'
import { useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import InfoFields from 'shared/components/creation/info-fields'
import PrivacyAgreement from 'shared/components/creation/info-fields/privacy-agreement'
import { setCreationStatus, STATUS } from 'shared/redux/creation-tool'
import creationToolUpload from 'shared/redux/creation-tool-upload'
import styled from 'styled-components'
import { ZoomMakerFrame, ZoomMakerStatus } from '../types'
import Preview from '../upload-preview'

const Container = styled.div`
    display: flex;
`

const Canvas = styled(Preview)`
    flex-shrink: 0;
    height: 298px;
    margin-right: 10px;
    position: relative;
    width: 530px;
`

const Info = styled.div`
    background: ${giphyDarkestGrey};
    margin-bottom: 6px;
    padding: 30px;
    width: 100%;
`

const Buttons = styled.div`
    display: flex;

    button {
        font-size: 15px;
        width: 100%;
    }
    button:first-child {
        background: ${giphyDarkestGrey};
        margin-right: 6px;
        width: 160px;
    }
`

type Props = {
    canvasFrames: ZoomMakerFrame[]
    canvasStickers: any[]
    creationToolUpload: (frames: ZoomMakerFrame[], jobId: string, stickerIds: string[]) => Promise<string>
    setCreationStatus: (status: string) => void
}

const ZoomMakerUpload = ({ canvasFrames, canvasStickers, creationToolUpload, setCreationStatus }: Props) => {
    const [status, setStatus] = useState<ZoomMakerStatus>(ZoomMakerStatus.Idle)
    const { goBack } = useHistory()

    const onUpload = async () => {
        setStatus(ZoomMakerStatus.Uploading)
        try {
            const gifId = await creationToolUpload(canvasFrames, 'giphybackdrop', canvasStickers)
            if (gifId) {
                setStatus(ZoomMakerStatus.Complete)
                setTimeout(() => {
                    location.href = '/gifs/' + gifId
                }, 700)
            } else {
                throw 'No GIF ID'
            }
        } catch (e) {
            setCreationStatus(STATUS.ERROR)
            setStatus(ZoomMakerStatus.Idle)
        }
    }

    return (
        <Container>
            <Canvas frames={canvasFrames} status={status} />
            <div
                style={
                    status !== ZoomMakerStatus.Idle
                        ? { filter: 'grayscale(100%)', opacity: 0.7, pointerEvents: 'none' }
                        : {}
                }
            >
                <Info>
                    <InfoFields canUploadAsVideo={false} />
                    <PrivacyAgreement />
                </Info>
                <Buttons>
                    <Button secondary onClick={goBack}>
                        Cancel
                    </Button>
                    <Button onClick={onUpload}>Upload to GIPHY</Button>
                </Buttons>
            </div>
        </Container>
    )
}

export default connect(null, { creationToolUpload, setCreationStatus })(ZoomMakerUpload)
